import { TranslationKeys } from '../index';

export const ar: TranslationKeys = {
  betBuilder: {
    title: 'منشئ الرهانات',
    noBetsSelected: 'منشئ الرهانات فارغ',
    addSelections: 'إضافة اختيارات',
    totalOdds: 'إجمالي الاحتمالات',
    totalSelections: 'إجمالي الاختيارات',
    clearAll: 'مسح الكل',
    removeBet: 'إزالة الرهان',
    addBet: 'إضافة رهان',
    event: 'الحدث',
    market: 'السوق',
    selection: 'الاختيار',
    odds: 'الاحتمالات',
    confirmClear: 'مسح جميع الرهانات',
    confirmClearMessage: 'هل أنت متأكد من أنك تريد إزالة جميع الرهانات؟ لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    confirm: 'مسح الكل',
    closed: 'مغلق',
    suspend: 'تعليق',
    eventClosed: 'الحدث مغلق',
    eventSuspended: 'الحدث معلق',
    buildABet:''
  },
  betStatus: {
    won: 'فائز',
    pending: 'معلق',
    refund: 'استرداد',
    lost: 'خاسر',
    halfwon: 'فائز جزئياً',
    halflost: 'خاسر جزئياً',
    cashout: 'سحب نقدي',
    unknown: 'غير معروف'
  },
  common: {
    loading: 'جاري التحميل...',
    error: 'خطأ',
    retry: 'إعادة المحاولة',
    close: 'إغلاق',
    save: 'حفظ',
    edit: 'تحرير',
    delete: 'حذف',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    search: 'بحث',
    filter: 'تصفية',
    sort: 'ترتيب',
    settings: 'الإعدادات'
  },
  errors: {
    generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    network: 'خطأ في الشبكة. يرجى التحقق من اتصالك.',
    notFound: 'لم يتم العثور على المورد المطلوب.',
    unauthorized: 'غير مخول لك تنفيذ هذا الإجراء.',
    validation: 'يرجى التحقق من إدخالك والمحاولة مرة أخرى.'
  }
};